import { Flex } from '@/components/ui/flex'
import { Skeleton } from '@/components/ui/skeleton'
import { Stack } from '@/components/ui/stack'

const MessagesSkeleton = () => {
    const skeletonHeight = '20px'
    return (
        <Stack mt="24px">
            <Flex direction="row" justifyContent="flex-start">
                <Skeleton height="80px" width="90%" />
            </Flex>
            <Flex direction="column" gap="15px">
                <Skeleton height="20px" width="40%" />
                <Skeleton height="20px" width="50%" />
                <Skeleton height="20px" width="30%" />
            </Flex>
            <Flex direction="row" justifyContent="flex-start" mt="15px">
                <Skeleton height={skeletonHeight} width="10%" mr="16px" />
                <Skeleton height={skeletonHeight} width="10%" mr="16px" />
                <Skeleton height={skeletonHeight} width="10%" />
            </Flex>
        </Stack>
    )
}

export default MessagesSkeleton
